
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './foodculture.json';

const Foodculture = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Explore global food traditions, dining etiquette, and culinary vocabulary. B2 English exercises with grammar, reading, and speaking practice."
            level="B2"
            title="Food Culture"
            image="/Images/foodculture1.webp"
            seoTitle="Free English Lesson Plans: Food Culture"
            seoDescription="Explore global food traditions, dining etiquette, and culinary vocabulary. B2 English exercises with grammar, reading, and speaking practice."
        >
                       
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Foodculture;


